import { mapGetters, mapState } from 'vuex';

export default {
    computed: {
        ...mapState([
            'selectedProducts',
        ]),

        ...mapGetters([
            'productCurrency',
            'hasSelectedProducts',
            'hasSelectedAddonProducts',
            'selectedProductIds',
            'selectedAddonProducts',
            'selectedAddonProductIds',
            'payableProducts',
            'reservableProducts',

            'totalProductsDurationInMinutes',
            'totalProductsDurationFormatted',
            'totalAddonProductsDurationInMinutes',
            'totalAddonProductsDurationFormatted',

            'productPaymentOptional',

            'totalProductsPrice',
            'totalProductsPriceFormatted',

            'totalProductsPriceWithGiftcard',
            'totalProductsPriceWithGiftcardFormatted',

            'totalProductsPriceWithDiscount',
            'totalProductsPriceWithDiscountFormatted',

            'totalAddonProductsPrice',
            'totalAddonProductsPriceFormatted',
            'totalPrice',
            'totalPriceFormatted',
            'totalPriceToPayNow',
            'totalPriceToPayNowFormatted',
            'finalPrice',
            'finalPriceFormatted',

            'totalProductsRatePrice',
            'totalProductsRatePriceFormatted',

            'productsWithPaymentRates',
            'hasProductsWithPaymentRates',
            'paymentRatesReferenceProduct',

            'used_voucher',

            'giftcard',
            'giftcardMoneyUsedForThisBooking',
            'giftcardMoneyUsedForThisBookingFormatted',

            'discount_code',
            'discountMoneyUsedForThisBooking',
            'discountMoneyUsedForThisBookingFormatted',

            'selectedProductsWithAddons',
            'hasAddonsAvailableToSelect',
        ]),
    }
}
